var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights } from '../../defaultTheme';
const Small = styled((_a) => {
    var { isInline, children, className } = _a, props = __rest(_a, ["isInline", "children", "className"]);
    return isInline ? (_jsx("span", Object.assign({ className: className }, props, { children: children }))) : (_jsx("p", Object.assign({ className: className }, props, { children: children })));
}) `
  font-size: ${fontSizes.small}px;
  line-height: ${lineHeights.largest};
  font-weight: ${({ weight }) => fontWeights[weight || 'regular']};
  margin: 0;

  &:focus {
    outline: none;
  }
`;
export default Small;
//# sourceMappingURL=Small.js.map